export enum userCreateProfileTypes {
  SET_USERCREATE_PROFILE = "SET_USERCREATE_PROFILE",
  GET_USERCREATE_PROFILE = "GET_USERCREATE_PROFILE",
}
